/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable @typescript-eslint/no-explicit-any */
export default function resolve(obj: any, path: string): any {
  if (typeof obj !== 'object') return false;

  return path.split('.').reduce((prev: any, curr: string) => {
    return prev ? prev[curr] : null;
  }, obj);
}
